import {
  Col,
  Divider,
  Form,
  Input,
  Row,
  Select,
  Switch,
  Typography,
} from "antd";
import { labelConfig } from "../../reports.config";
import { BOM } from "../../../../services/definedMethod";
import React from "react";
const { Text, Title } = Typography;
const { TextArea } = Input;
export default function DetailScreen({ reportDetail }) {
  const [form] = Form.useForm();
  const reportType = reportDetail?.reportType || "";
  console.log(reportDetail);
  React.useEffect(() => {
    if (reportDetail) {
      form.setFieldsValue({
        ...reportDetail,
        useReport: reportDetail?.useReport || false,
        reportCategory: reportDetail?.reportCategory?.parameterName || "-",
      });
    }
  }, [reportDetail, form]);
  return (
    <Form form={form} layout="vertical" name="customer-info">
      <Row>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={labelConfig.reportName} name="reportName">
            <Input
              className="of-bold-disable-input"
              disabled
              placeholder={BOM.handlePlaceholderMsg(labelConfig.reportName)}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={labelConfig.reportCategory} name="reportCategory">
            <Input
              className="of-bold-disable-input"
              disabled
              placeholder={BOM.handlePlaceholderMsg(labelConfig.reportCategory)}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={labelConfig.reportType} name="reportType">
            <Select
              disabled
              className="read-only-select"
              placeholder={BOM.handlePlaceholderMsg(
                `${labelConfig.reportType}`,
                "select"
              )}
              showSearch
            />
          </Form.Item>
        </Col>
        <Col span={16} style={{ padding: "0px 8px" }}>
          <Form.Item label={labelConfig.description} name="description">
            <TextArea
              disabled
              className="of-bold-disable-input"
              style={{ minHeight: 100 }}
              placeholder={BOM.handlePlaceholderMsg(labelConfig.description)}
            />
          </Form.Item>
        </Col>
        {reportType &&
          reportType?.toLowerCase() !== "table" &&
          reportType?.toLowerCase() !== "pentaho" && (
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.reportSubType} name="reportSubType">
                <Select
                  disabled
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.reportSubType}`,
                    "select"
                  )}
                  showSearch
                  className="read-only-select"
                />
              </Form.Item>
            </Col>
          )}

        <Col
          span={8}
          style={{
            padding: "0px 8px",
            marginTop: 30,
            display: "flex",
            gap: 10,
          }}
        >
          <Form.Item
            name={"useReport"}
            style={{ margin: 0, padding: 0 }}
            valuePropName="checked"
          >
            <Switch disabled className="custom-switch-2" />
          </Form.Item>
          <Text style={{ margin: 0, color: "#667085", marginTop: 5 }}>
            User Report UI
          </Text>
        </Col>
      </Row>

      {reportType && reportType?.toLowerCase() !== "pentaho" && (
        <>
          <Divider orientation="left" orientationMargin="0">
            <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
              {labelConfig.SQL}
            </Title>
          </Divider>
          <Row>
            <Col span={24} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.SQL} name="reportSql">
                <TextArea
                  className="of-bold-disable-input"
                  disabled
                  style={{ minHeight: 100 }}
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.SQL)}
                />
              </Form.Item>
            </Col>
          </Row>
        </>
      )}
    </Form>
  );
}
